import ApiService from "@/core/services/ApiService";
import JwtService from "@/core/services/JwtService";
import { Actions, Mutations } from "@/store/enums/StoreEnums";
import { Module, Action, Mutation, VuexModule } from "vuex-module-decorators";

export interface DuLieuChiTieu {
  name: string;
  api_token: string;
}

export interface DuLieuChiTieuDetaiInfor {
  errors: unknown;
  DuLieuChiTieu: DuLieuChiTieu;
  isAuthenticated: boolean;
}

@Module
export default class DuLieuChiTieuDetail
  extends VuexModule
  implements DuLieuChiTieuDetaiInfor
{
  errors = {};
  DuLieuChiTieu = {} as DuLieuChiTieu;
  isAuthenticated = !!JwtService.getToken();

  /**
   * Get current user object
   * @returns User
   */
  get DuLieuChiTieuDetail() {
    return this.duLieuChiTieuDetailData;
  }

  /**
   * Verify user authentication
   * @returns boolean
   */

  @Mutation
  [Mutations.SET_ERROR](error) {
    this.errors = { ...error };
  }

  @Mutation
  [Mutations.DU_LIEU_CHI_TIEU_DETAIL_DATA](DuLieuChiTieu) {
    this.duLieuChiTieuDetailData = DuLieuChiTieu;
  }
  @Action
  [Actions.DU_LIEU_CHI_TIEU_DETAIL](payload) {
    return ApiService.getDataDetail(
      "/solieu_chitieu_tk",
      payload,
      "detail",
      payload
    )
      .then(({ data }) => {
        this.context.commit(Mutations.DU_LIEU_CHI_TIEU_DETAIL_DATA, data);
      })
      .catch(({ response }) => {
        this.context.commit(Mutations.PURE_AUTH_AND_SET_ERROR, response.data);
      });
  }
}
